import { render, staticRenderFns } from "./single-image.vue?vue&type=template&id=3c839cee&scoped=true"
import script from "./single-image.vue?vue&type=script&lang=js"
export * from "./single-image.vue?vue&type=script&lang=js"
import style0 from "./single-image.vue?vue&type=style&index=0&id=3c839cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c839cee",
  null
  
)

export default component.exports